<template>
  <div class="case-item" @click="jumpCaseDetail">
    <div class="top">
      <img class="avatar" :src="data.info.user_head" />
      <div class="top-right">
        <div class="info-top">
          <div class="nickname">{{ data.info.nickname || '' }}</div>
          <div class="featured" @click.stop="checkboxChange">
            <span class="checkbox-text">设置公开</span>
            <span
              class="checkbox"
              :class="{
                'checkbox-active iconfont icon-gou': data.info.is_public == 1
              }"
            ></span>
          </div>
        </div>
        <div class="coach-name">
          <span v-if="data.info.product_alias_name"
            >{{ data.info.product_alias_name }}学员</span
          ><span v-if="data.info.coach_name">
            - {{ data.info.coach_name }}</span
          >
        </div>
        <div class="tag-list" v-if="data.info.label_data">
          <div
            class="tag-item"
            v-for="(item, index) in data.info.label_data"
            :key="index"
          >
            {{ item }}
          </div>
        </div>
      </div>
    </div>
    <div class="center">
      <div class="center-content">
        <div class="title">{{ data.title }}</div>
        <div class="image-content" v-if="data.info.comparison_img.length >= 2">
          <div class="image-item" v-if="data.info.comparison_img[0]">
            <div class="compare-image-content">
              <img class="compare-image" :src="data.info.comparison_img[0]" />
            </div>
            <div class="image-text">入营前</div>
          </div>
          <div class="image-item" v-if="data.info.comparison_img[1]">
            <div class="compare-image-content">
              <img class="compare-image" :src="data.info.comparison_img[1]" />
            </div>
            <div class="image-text">入营后</div>
          </div>
        </div>
        <div class="keyword-content">
          <span>关键词：</span>
          <span class="keyword">{{ data.keyword1 }}</span>
          <span class="keyword">{{ data.keyword2 }}</span>
          <span class="keyword">{{ data.keyword3 }}</span>
        </div>
      </div>
    </div>
    <div class="bottom">
      <div class="icon-list">
        <span class="icon-item" @click.stop="bindCollectDynamic">
          <span
            class="iconfont icon-shixinxingxing"
            :class="{ 'collet-active': data.is_save === 0 }"
          ></span>
          <span>{{ data.save_num | formatDynamicNumber }}</span>
        </span>
        <span class="icon-item" @click.stop="bindlikeDynamic">
          <span
            class="iconfont icon-dianzan_kuai"
            :class="{ 'like-active': data.info.is_useful }"
          ></span>
          <span>{{ data.info.useful | formatDynamicNumber }}</span>
        </span>
      </div>
      <div class="public-content" v-if="data.info.way_data.length">
        <span>可公开渠道：</span>
        <img
          class="public-image"
          v-for="(item, index) in data.info.way_data"
          :key="index"
          :src="item.icon"
        />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    data: {
      type: Object,
      default: () => {
        {
        }
      }
    }
  },
  filters: {
    formatDynamicNumber(num) {
      if (!num && num !== 0) {
        return ''
      }
      var res = ''
      num = isNaN(parseInt(num)) ? '-' : parseInt(num)
      if (num === '-') {
        return '-'
      }
      if (num >= 100000) {
        res = '10w+'
      } else if (num >= 10000) {
        res = (num / 10000).toFixed(1) + 'w'
      } else if (num >= 1000) {
        res = (num / 1000).toFixed(1) + 'k'
      } else {
        res = num
      }
      return res
    }
  },
  data() {
    return {
      checked: false,
      loading: false //是否在请求中
    }
  },
  created() {
    this.data.info.comparison_img = this.data.info.comparison_img.filter(
      (item) => {
        return item
      }
    )
  },
  methods: {
    // 点赞这个文章
    bindlikeDynamic() {
      let params = {
        data_id: this.data.info.id,
        opt: this.data.info.is_useful ? 0 : 1
      }
      this.$http
        .postApp('member/StorageLogin/setCaseUseful', params)
        .then((res) => {
          res = res.data
          if (res.code == 200) {
            let data = this.data.info
            data.is_useful = data.is_useful === 0 ? 1 : 0
            if (data.is_useful) {
              this.data.info.useful = data.useful + 1
              this.$toast('点赞成功')
            } else {
              data.useful = --data.useful < 0 ? 0 : data.useful
              this.$toast('取消点赞')
            }
          } else {
            this.$toast(res.msg)
          }
        })
        .catch((e) => {
          console.log(e)
        })
    },
    //收藏
    bindCollectDynamic() {
      let params = {
        tid: this.data.id,
        type_0: this.data.type_id,
        type: this.data.is_save === 0 ? 2 : 1
      }
      this.$http
        .postApp('member/StorageLogin/optSave', params)
        .then((res) => {
          res = res.data
          if (res.code == 200) {
            let data = this.data
            data.is_save = data.is_save === 0 ? 1 : 0
            if (data.is_save === 0) {
              data.save_num = data.save_num + 1
              this.$toast('收藏成功')
            } else {
              data.save_num = --data.save_num < 0 ? 0 : data.save_num
              this.$toast('取消收藏')
            }
          } else {
            this.$toast(res.msg)
          }
        })
        .catch((e) => {
          console.log(e)
        })
    },
    concatUrlParams(params) {
      let str = ''
      let isFirst = true
      for (let i in params) {
        let itemStr
        let paramStr =
          typeof params[i] == 'string' ? params[i] : JSON.stringify(params[i])
        if (isFirst) {
          itemStr = '?' + i + '=' + paramStr
          isFirst = false
        } else {
          itemStr = '&' + i + '=' + paramStr
        }
        str = str + itemStr
      }
      return str
    },
    jumpCaseDetail() {
      let params = {
        id: this.data.id,
        typeId: this.data.type_id
      }
      this.$router.push({
        path: '/fatcamp/knowledge-base/case-detail',
        query: params
      })
    },
    checkboxChange() {
      let checked = this.data.info.is_public == 1
      if (this.loading) {
        this.$toast('请稍后再试')
        return
      }
      if (!checked) {
        this.$dialog
          .confirm({
            title: '提示',
            message: '是否将这条案例公开？'
          })
          .then(() => {
            this.setCase(true)
          })
          .catch(() => {})
      } else {
        this.$dialog
          .confirm({
            title: '提示',
            message: '是否取消这条案例的公开？'
          })
          .then(() => {
            this.setCase(false)
          })
          .catch(() => {})
      }
    },
    setCase(checked) {
      this.loading = true
      let params = {
        id: this.data.info.id
      }
      this.$http
        .postApp('member/StorageLogin/casePublic', params)
        .then((res) => {
          res = res.data
          if (res.code == 200) {
            this.data.info.is_public = checked ? 1 : 2
            let tips =
              this.data.info.is_public == 1 ? '设置公开成功' : '取消公开成功'
            this.$toast(tips)
          } else {
            this.$toast(res.msg)
          }
          this.loading = false
        })
        .catch((err) => {
          this.loading = false
        })
    }
  }
}
</script>
<style lang="scss"></style>
<style lang="scss" scoped>
.case-item {
  width: 100vw;
  background: #fff;
  padding: 4vw 5.3vw;
  margin: 2.7vw 0vw;
  box-sizing: border-box;
}
.info-top {
  display: flex;
  align-items: center;
  margin-bottom: 3px;
}
.center {
  background: #f7f7f7;
  border-radius: 8px;
  margin-bottom: 2.7vw;
}
.center-content {
  padding: 8px 12px 10px;
}
.center-content .title {
  padding-left: 4px;
  font-size: 16px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 600;
  color: #000;
  line-height: 24px;
  margin-bottom: 7px;
}
.image-content {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 10px;
}
.image-item {
  width: 50%;
  box-sizing: border-box;
  background: #fff;
  border-radius: 1px;
  padding: 10px 10px 12px;
  box-sizing: border-box;
  overflow: hidden;
  border: 1px solid #e7e7e7;
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.1);
}
.compare-image-content {
  width: 136px;
  height: 210px;
  margin-bottom: 9px;
}
.compare-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.compare-empty {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.5);
  background-color: #f2f2f2;
}
.image-text {
  text-align: center;
  font-size: 12px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #000;
  line-height: 17px;
  text-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);
}
.center .mask {
  padding: 4.3vw 5.3vw;
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: 2;
  left: 0;
  top: 0;
  display: flex;
  align-items: flex-end;
  text-align: left;
  background-image: linear-gradient(
    0deg,
    rgba(0, 0, 0, 1),
    rgba(0, 0, 0, 0.3) 40%,
    rgba(0, 0, 0, 0)
  );
}
.mask .say {
  font-family: PingFangSC-Regular;
  font-size: 4vw;
  line-height: 5.9vw;
  color: #fff;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}
.keyword-content {
  text-align: left;
  font-family: PingFangSC-Regular;
  font-size: 3.2vw;
  color: rgba(0, 0, 0, 0.5);
}
.keyword-content .keyword {
  font-family: PingFangSC-Medium;
  font-size: 3.2vw;
  color: #2882e9;
  margin-right: 2.1vw;
}
.top {
  display: flex;
  margin-bottom: 6px;
}
.top .featured {
  display: flex;
  align-items: center;
}
.checkbox {
  margin-left: 10px;
  display: inline-block;
  width: 20px;
  height: 20px;
  background-color: #ffffff;
  border-radius: 6px;
  color: #fff;
  text-align: center;
  line-height: 20px;
  border: solid 1px #dddddd;
  box-sizing: border-box;
  font-size: 14px;
}
.checkbox-active {
  background: #2882e9;
  color: #fff;
  border: none;
}
.top-right {
  flex: 1;
  flex-shrink: 0;
  overflow: hidden;
}
.top .featured .checkbox-text {
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  color: rgba(0, 0, 0, 0.5);
}
.top .avatar {
  width: 9.6vw;
  height: 9.6vw;
  margin-right: 2.7vw;
  border-radius: 2.7vw;
  overflow: hidden;
}
.top .nickname {
  flex: 1;
  flex-shrink: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-family: PingFangSC-Medium;
  font-size: 3.2vw;
  color: #000;
}
.top .coach-name {
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  line-height: 17px;
  color: rgba(0, 0, 0, 0.5);
  margin-bottom: 6px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.tag-list {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}
.tag-list .tag-item {
  background: #fff;
  border-radius: 4px;
  border: 1px solid #f1f1f1;
  padding: 5px 9px;
  box-sizing: border-box;
  margin-right: 7px;
  margin-bottom: 7px;
  font-size: 10px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #000;
}
.bottom {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.bottom .public-content {
  display: flex;
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  color: rgba(0, 0, 0, 0.5);
  line-height: 17px;
}
.bottom .icon-list {
  font-size: 12px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: rgba(56, 61, 72, 0.5);
  line-height: 17px;
}
.icon-list .icon-item {
  margin-right: 16px;
}
.icon-list .icon-item:last-child {
  margin-right: 0px;
}
.bottom .icon-list .iconfont {
  color: rgba(0, 0, 0, 0.2);
  font-size: 16px;
  margin-right: 6px;
}
.bottom .icon-list .collet-active {
  color: #f7b500;
}
.bottom .icon-list .like-active {
  color: #2882e9;
}
.public-content .public-image {
  width: 20px;
  height: 20px;
  margin-right: 5px;
}
.public-content .public-image:last-child {
  margin-right: 0px;
}
</style>
